module.exports = __webpack_public_path__ + "static/media/15_tn.4f641ea9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/15_tn.jpg
// module id = 324
// module chunks = 0